import { getConfigs } from '../confs/store.conf';
import { userHasOneOfRoles } from '../utils/conf.utils';
import loadScript from './load-script';
import { isAppSmart } from './external-nav';
import { FLAGS } from '../confs/flags.conf';

const merchantRoles = [
	'CHANNEL_PRODUCT_SUPPORT',
	'CHANNEL_SUPPORT',
	'CHANNEL_ADMIN',
	'REPORTS_CHANNEL_ADMIN',
	'CORPORATE_ADMIN',
	'SALES_SUPPORT',
	'RESELLER_MANAGER',
	'SUPERUSER',
	'SUPER_SUPPORT',
];

window.isGlobalHeaderEnabled = false;

const staticMerchantNav = `${location.origin}/merchant-nav/merchant-nav.js`;

export const isIframe = () => {
	try {
		return window.self !== window.top;
	} catch (e) {
		return true;
	}
};

const hideTrialBanner = () => {
	const trialBanner = document.querySelector('#header #fixedNav');
	if (trialBanner) {
		trialBanner.style.display = 'none';
	} else {
		const styleSheet = document.createElement('style');
		styleSheet.type = 'text/css';
		styleSheet.innerText = '#header #fixedNav {display: none;}';
		document.head.appendChild(styleSheet);
	}
};
export const needsMerchantNav = () => {
	const channel = getConfigs('CHANNEL_SETTINGS');
	const isMerchantMarketplace = channel.selfserveMarketplace;
	const isMerchantNavPage = !getConfigs('isMarketplace') && getConfigs('useTemplate') !== 'headerCheckout';
	const isExpired = channel ? channel.accountStatus === 'FREE_TRIAL_EXPIRED' : false;
	const globalNavigationEnabled = channel.globalNavigationEnabled;

	return (
		isMerchantMarketplace &&
		!isIframe() &&
		isMerchantNavPage &&
		((userHasOneOfRoles(merchantRoles) || isExpired) ||
		globalNavigationEnabled)
	);
};

export const shouldLoadGlobalHeader = async (partner) => {
	const channel = getConfigs('CHANNEL_SETTINGS');
	const globalNavigationEnabled = channel?.globalNavigationEnabled;
	// Check if forceGlobalHeader query param is set to true and store it in session storage
	const urlParams = new URLSearchParams(window.location.search);
	const forceGlobalHeaderParam = urlParams.get('forceGlobalHeader');

	const isAppsmartInt = window.location.host === 'appsmart.cyanopica.appdirect-test.io';
	const isAppsmartTestEnv = window.location.host === 'testcatalog.appdirect.com';
	const isAppsmartSandbox = window.location.host === 'catalogsandbox.byappdirect.com';
	const isAppsmartProd = window.location.host === 'catalog.appdirect.com';

	// Check bypass conditions first - these should always return true without checking flags
	if (forceGlobalHeaderParam === 'true' || 
		isAppsmartTestEnv || 
		isAppsmartInt ||
		isAppsmartProd ||
		partner === 'APPSMART' ||
		partner === 'APPSMARTSANDBOX' || 
		isAppsmartSandbox ||
		globalNavigationEnabled) {
		window.isGlobalHeaderEnabled = true;
		window.sessionStorage.setItem('forceGlobalHeader', 'true');
		return true;
	}

	// Check session storage for forced global header
	if (window.sessionStorage.getItem('forceGlobalHeader') === 'true') {
		window.isGlobalHeaderEnabled = true;
		return true;
	}

	// Check the feature flag for global header (flags should already be initialized by now)
	const configs = getConfigs();
	const flags = configs.flags;
	
	if (flags && flags[FLAGS.GLOBAL_HEADER_ENABLED]) {
		window.isGlobalHeaderEnabled = true;
		window.sessionStorage.setItem('forceGlobalHeader', 'true');
		return true;
	}
	window.sessionStorage.setItem('forceGlobalHeader', 'false');
	return false;
};

const loadInterFont = () => {
	const link = document.createElement('link');
	link.rel = 'stylesheet';
	link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@100..700&display=block';
	document.head.appendChild(link);
};

const getPublishedThemeHeaderColor = (partner) => {
	try {
		const userUuid = getConfigs('userUUID');
		if (!partner || !userUuid) return null;
		const storageKey = `${partner}_${userUuid}_merchant_nav`;
		const raw = window.sessionStorage.getItem(storageKey);
		if (!raw) return null;
		const parsed = JSON.parse(raw);
		const queries = parsed && parsed.clientState && parsed.clientState.queries;
		if (!Array.isArray(queries)) return null;
		for (const query of queries) {
			const queryKey = query && query.queryKey;
			if (Array.isArray(queryKey) && queryKey[0] === 'published-theme-settings') {
				const color = query && query.state && query.state.data && query.state.data.headerBackgroundColor;
				if (typeof color === 'string' && color.trim()) return color;
			}
		}
		return null;
	} catch (e) {
		return null;
	}
};

// help pages render better with a min-height that stop the page jumping around
const setHeaderheight = async (headerSelector, partner, globalNavigationEnabled) => {
	// this is set by merchant nav, we only do this for v2
	const globalHeaderEnabled = await shouldLoadGlobalHeader(partner);
	if(window.sessionStorage.getItem(`AD:APPS:STORAGE:feature-flag-merchant-nav-v2:${partner}`) === 'true' || globalHeaderEnabled)  {
		const header = document.querySelector(headerSelector);
		if (header) {
			header.style.minHeight = '64px';
			if (isAppSmart()) {
				header.style.backgroundColor = '#011B58';
			} else if (globalNavigationEnabled) {
				const themeColor = getPublishedThemeHeaderColor(partner);
				if (themeColor) {
					header.style.backgroundColor = themeColor;
				}
			} else {
				header.style.backgroundColor = '#000000';
			}
		}
	}
}

let loaded = false;
export const loadMerchantNav = async () => {
	if (!loaded) {
		const {
			channel,
			footer,
			isPositionFixed,
			marketUrl,
			token,
			bootstrap,
			myapps,
			header,
			CHANNEL_SETTINGS,
		} = getConfigs();

		const merchantNavConfig = {
			channel,
			isPositionFixed,
			marketUrl,
			token,
			bootstrap,
			myapps,
			header,
			CHANNEL_SETTINGS,
		};
		window.ad_merchant_nav_config = merchantNavConfig;
		window.ad_merchant_nav_config.footer = footer;
		await setHeaderheight(merchantNavConfig.header.renderTo, CHANNEL_SETTINGS?.partner, CHANNEL_SETTINGS?.globalNavigationEnabled);
		hideTrialBanner();
		loadInterFont();
		loadScript(staticMerchantNav);
		loaded = true;
	} else {
		document.dispatchEvent(new CustomEvent('mnav:reload'));
	}
};
